import { useEffect, useState } from 'react';
import useLocalStorage from '@alltrails/local-storage/useLocalStorage';

const pageLimitReachedKey = 'page-limit-reached';

// Marks that a qualifying page has been viewed so a later view can be detected as a subsequent
// (2nd+) page view. Call this somewhere that renders on every qualifying view (e.g. ViewLimitHandler),
// not inside a conditionally-rendered treatment, otherwise views can be undercounted.
// Pass `enabled: false` for visitors who should not advance the counter (e.g. logged-in or PageViewLimit path).
const usePageViewLimit = (enabled = true) => {
  const { getValue: getPageLimitReached, setValue: setPageLimitReached } = useLocalStorage<boolean>(pageLimitReachedKey, false);

  // Snapshot the value BEFORE the mount effect flips it -> true means this is a subsequent (2nd+) page view.
  const [hasReachedPageLimit] = useState(() => getPageLimitReached() ?? false);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    if (!getPageLimitReached()) {
      setPageLimitReached(true);
    }
  }, [enabled, getPageLimitReached, setPageLimitReached]);

  return { hasReachedPageLimit };
};

export default usePageViewLimit;
